import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { startLoading, stopLoading } from "./application";

declare const window: any;

export const paymentOptionsApi = createApi({
    reducerPath: 'paymentOptionsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_PAYMENT_OPTIONS_LINK ?? "https://npr-payment-options-handler.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS_PAYMENT ?? "Tri6v0RY3x9Ez4TJGMnycaxjwJpAtUpM3GrR6fNq")
            return headers
        },
    }),

    tagTypes: ['PaymentOptions'],
    endpoints: (builder) => ({
        getPaymentOptions: builder.query({
            query: ({locale, custId, cartId, thresholdDateValue, thresholdCartValue}) => ({
                url : `v1/getPaymentOptions/${locale}/${custId}/${cartId}${thresholdDateValue ? `?thresholdDateValue=${thresholdDateValue}` : ''}${thresholdCartValue ? `${thresholdDateValue ? '&' : '?'}thresholdCartValue=${thresholdCartValue}` : ''}`,
                method: 'GET',
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try{
                    dispatch(startLoading());
                    const {data} = await queryFulfilled;
                    return data;
                }
                catch(error){
                    console.log(error);
                } finally {
                    dispatch(stopLoading())
                }
            },
        }),
    }),
})

export const { useGetPaymentOptionsQuery } = paymentOptionsApi;